"use client";
import MobileSelect from "../../baseSelect/mobiles/MultiSelect/index.mobile";
import { formatJobFunctions } from "../../helper";
import { expandSelectedValues, restoreOriginalObjectMobile } from "./helper";
import styles from "./index.module.scss";
import EmptyImage from "../assets/empty.png";
import { useSharedData } from "bossjob-remote/dist/hooks";

type Valuetype = {
  mainFunctions: string[];
  jobFunctions: string[];
  functionTitles: string[];
};

type PropsType = {
  main_function_filter?: any[];
  value?: Valuetype;
  isMulty?: boolean;
  onChange?: (any) => void;
  jobFunctionText?: string;
  searchJobFunctionText?: string;
};

function JobFunctionSelectMobile({
  main_function_filter = [],
  value,
  isMulty = true,
  onChange,
  jobFunctionText = "Job Functions",
  searchJobFunctionText = "Search Job Function"
}: PropsType) {
  const options = formatJobFunctions(main_function_filter);
  const newValue = expandSelectedValues(value, options);
  const dictionary = useSharedData("DICTIONARY") || {};

  const restoreProviderValue = (value) => {
    const changeValue = restoreOriginalObjectMobile(value, options);
    if (onChange) {
      onChange(changeValue);
    }
  };

  return (
    <MobileSelect
      // @ts-ignore
      placeholder={searchJobFunctionText}
      searchTitle={jobFunctionText}
      value={newValue}
      isMulty={isMulty}
      options={options}
      onChange={restoreProviderValue}
      title={jobFunctionText}
      empty={
        <div className={styles.empty}>
          <img src={EmptyImage.src} />
          <p className={styles.emptyDesc}>
            {dictionary?.common?.jobFunctionSelectorEmpty ||
              "Try another keyword, or directly choose from our dropdown selector."}
          </p>
        </div>
      }
    />
  );
}

export default JobFunctionSelectMobile;
